import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import "../../../customComponents/WalletOverviewSkeleton/walletOverviewSkeleton.css";
import {
  formatSpotPnl,
  normalizeSpotPnlSummary,
  spotPnlColorClass,
} from "./walletPageHelpers";


function SpotPnlSkeleton() {
  return (
    <div className="funding-account__spot-pnl-sk" aria-busy="true" aria-label="Loading PnL">
      <span className="agce-wallet-ov-sk__bone funding-account__spot-pnl-sk__val" aria-hidden />
    </div>
  );
}

/** Spot chrome: “Total Assets” block + eye toggle + 24h realized PnL */
export function WalletTotalsSpotSection({
  showBalance,
  setShowBalance,
  portfolioPreferredAmountOrZero,
  portfolioPreferredCurrency,
  portfolioUsdtEstimateOrZero,
  portfolioData,
  safeRound,
  spotPnlData,
  spotPnlLoading,
}) {
  const pnl = useMemo(() => normalizeSpotPnlSummary(spotPnlData), [spotPnlData]);
  const pnlAsset = pnl?.asset || "USDT";
  const realizedPnl = pnl?.realizedPnl;

  return (
    <div className="funding-account__toprow">
      <div className="funding-account__totals">
        <div className="funding-account__totals-label">
          Total Assets
          <button
            type="button"
            onClick={() => setShowBalance((p) => !p)}
            aria-label={showBalance ? "Hide balances" : "Show balances"}
            style={{ marginLeft: 8, border: "none", background: "transparent", padding: 2, cursor: "pointer", verticalAlign: "middle" }}
          >
            <i className={showBalance ? "ri-eye-line" : "ri-eye-off-line"} aria-hidden="true" />
          </button>
        </div>
        <div className="funding-account__totals-main">
          <span className="funding-account__totals-num">{showBalance ? safeRound(portfolioPreferredAmountOrZero(portfolioData), 5) : "****"}</span>
          <span className="funding-account__totals-unit">{portfolioPreferredCurrency(portfolioData)}</span>
          <span className="funding-account__totals-sub">
            ≈ {showBalance ? safeRound(portfolioUsdtEstimateOrZero(portfolioData), 5) : "****"} {portfolioData?.Currency || "USD"}
          </span>
        </div>
      </div>

      <div className="funding-account__spot-pnl">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <div className="cmp-pnl-title d-flex align-items-center gap-2">
            24h PnL
            <Link to="/user_profile/wallet/spot/pnl-analysis" className="spot-pnl-analysis-link">
              Analysis
            </Link>
          </div>
        </div>
        {spotPnlLoading ? (
          <SpotPnlSkeleton />
        ) : (
          <div className={`cmp-pnl-val ${spotPnlColorClass(realizedPnl)}`}>
            {showBalance
              ? formatSpotPnl(realizedPnl, { asset: pnlAsset })
              : "****"}
          </div>
        )}
      </div>
    </div>
  );
}

/** Unified wallet chrome: labelled balance strip */
export function WalletTotalsUnifiedSection({
  walletLabel,
  showBalance,
  setShowBalance,
  portfolioPreferredAmountOrZero,
  portfolioPreferredCurrency,
  portfolioUsdtEstimateOrZero,
  portfolioData,
  safeRound,
}) {
  return (
    <div className="estimated_balance">
      <h6>
        {walletLabel} Balance
        <button type="button" onClick={() => setShowBalance((prev) => !prev)}>
          <i className={showBalance ? "ri-eye-line" : "ri-eye-off-line"} />
        </button>
      </h6>
      <div className="wallet-header d-flex flex-wrap align-items-center justify-content-between">
        <div>
          <div className="wallet-title">
            {showBalance
              ? `${safeRound(portfolioPreferredAmountOrZero(portfolioData), 5)} ${portfolioPreferredCurrency(portfolioData)}`
              : `**** ${portfolioPreferredCurrency(portfolioData)}`}
          </div>
          <div className="wallet-sub mt-1">
            ≈ {showBalance ? safeRound(portfolioUsdtEstimateOrZero(portfolioData), 5) : "****"} {portfolioData?.Currency || "USD"}
          </div>
        </div>
      </div>
    </div>
  );
}
